import { mount } from 'svelte';
// The stylesheets index.html used to load (the theme, then the same icon fonts and web fonts, now from npm), in the
// same order, before the components' styles. Both Font Awesome versions on purpose: the markup uses 6.x classes
// (fas, far) and 4.7 ones (fa), and 4.7 was linked last, so it wins where both set a rule.
import './styles/styles.css';
import '@fontsource/roboto-slab/400.css';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';
// the CSS (web font) only: Font Awesome's JS build re-scans the page on every DOM change
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'font-awesome/css/font-awesome.min.css';
import { startMocks } from 'virtual:sensay-dev-mocks';
import App from './App.svelte';
import { ANALYTICS_ENABLED, API_BASE_URL } from './config.js';
import { startI18n } from './i18n/index.js';
import { configureAnalytics } from './utils/analytics.js';
import { loadAnalyticsVendors } from './utils/analyticsVendors.js';

configureAnalytics({ enabled: ANALYTICS_ENABLED });
if (ANALYTICS_ENABLED) {
  loadAnalyticsVendors();
}

// mounted once the first dictionary is there, so the first render is already translated (and, in mocked
// development, once the mocked API answers, before the app's first call)
(startMocks ? startMocks({ apiBaseUrl: API_BASE_URL }) : Promise.resolve())
  .then(() => startI18n())
  .then(() => mount(App, { target: document.body }));
